import { IconType } from "react-icons";
import {
  TbAlertTriangle,
  TbBriefcase,
  TbGavel,
  TbParkingCircle,
  TbRefreshAlert,
  TbAdjustments,
  TbPlayerPause,
  TbAlertCircle,
  TbX,
  TbCircleCheck,
  TbHeartHandshake,
  TbCheck,
} from "react-icons/tb";
import type { TagProps } from "antd";
// import { LoanStatus } from "dtos/app-creditor-map.dto";
import { FREQUENCY_TYPES } from "dtos/loan.dto";

// export enum ACTION_TYPES {
//   CHANGE_LOAN_STATUS = "change_loan_status",
// }

// type LoanStatusMeta = {
//   label: string;
//   icon: IconType;
//   color: TagProps["color"];
//   actionHint?: string;
// };

// export const LOAN_STATUS_META: Record<LoanStatus, LoanStatusMeta> = {
//   [LoanStatus.TRIAGE]: {
//     label: "Triage",
//     icon: TbAlertTriangle,
//     color: "orange",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.TRIAGE}`,
//   },

//   [LoanStatus.ACTIVE_NEGOTIATION]: {
//     label: "Active Negotiation",
//     icon: TbBriefcase,
//     color: "processing",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.ACTIVE_NEGOTIATION}`,
//   },

//   [LoanStatus.LEGAL]: {
//     label: "Legal",
//     icon: TbGavel,
//     color: "volcano",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.LEGAL}`,
//   },

//   [LoanStatus.PARKED]: {
//     label: "Parked",
//     icon: TbParkingCircle,
//     color: "default",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.PARKED}`,
//   },

//   [LoanStatus.UPDATED_REQUIRED]: {
//     label: "Update Required",
//     icon: TbRefreshAlert,
//     color: "gold",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.UPDATED_REQUIRED}`,
//   },

//   [LoanStatus.MODIFICATION]: {
//     label: "Modification",
//     icon: TbAdjustments,
//     color: "purple",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.MODIFICATION}`,
//   },

//   [LoanStatus.PAUSED]: {
//     label: "Paused Payments",
//     icon: TbPlayerPause,
//     color: "cyan",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.PAUSED}`,
//   },

//   [LoanStatus.MISSED]: {
//     label: "Missed Payments",
//     icon: TbAlertCircle,
//     color: "error",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.MISSED}`,
//   },

//   [LoanStatus.CANCELLED]: {
//     label: "Cancelled Payments",
//     icon: TbX,
//     color: "red",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.CANCELLED}`,
//   },

//   [LoanStatus.COMPLETE]: {
//     label: "Completed Payments",
//     icon: TbCircleCheck,
//     color: "success",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.COMPLETE}`,
//   },

//   [LoanStatus.BUYOUT_NEGOTIATIONS]: {
//     label: "Buyout/Settlement Negotiations",
//     icon: TbHeartHandshake, // or you could use a different icon like TbHandshake
//     color: "geekblue",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.BUYOUT_NEGOTIATIONS}`,
//   },

//   [LoanStatus.BUYOUT_COMPLETED]: {
//     label: "Buyout/Settlement Completed",
//     icon: TbCheck, // or TbCheck
//     color: "green",
//     actionHint: `${ACTION_TYPES.CHANGE_LOAN_STATUS}:${LoanStatus.BUYOUT_COMPLETED}`,
//   },
// };

export const LoanFrequencyMultiplier: Record<FREQUENCY_TYPES, number> = {
  [FREQUENCY_TYPES.DAILY]: 1,
  [FREQUENCY_TYPES.WEEKLY]: 5,
  [FREQUENCY_TYPES.MONTHLY]: 5 * 4.33, // ~21.65
  [FREQUENCY_TYPES.YEARLY]: 5 * 4.33 * 12, // ~259.8
};

export const FrequencyLabel: Record<FREQUENCY_TYPES, string> = {
  [FREQUENCY_TYPES.DAILY]: "days",
  [FREQUENCY_TYPES.WEEKLY]: "weeks",
  [FREQUENCY_TYPES.MONTHLY]: "months",
  [FREQUENCY_TYPES.YEARLY]: "years",
};
